import {
  WORKFLOW_MESSAGE_TYPE_EMAIL,
  WORKFLOW_MESSAGE_TYPE_SMS
} from 'Api/beAutomationApi'

import {
  OPT_WORKFLOWS_LIST_TYPE_ABANDONED_CART__VALUE,
  OPT_WORKFLOWS_LIST_TYPE_BIRTHDAY__VALUE,
  OPT_WORKFLOWS_LIST_TYPE_EVENT_REMINDERS__VALUE,
  OPT_WORKFLOWS_LIST_TYPE_EVENT__VALUE,
  OPT_WORKFLOWS_LIST_TYPE_FIELD_CONDITION__VALUE,
  OPT_WORKFLOWS_LIST_TYPE_GROUP_CONDITION__VALUE,
  OPT_WORKFLOWS_LIST_TYPE_ONBOARDING__VALUE,
  OPT_WORKFLOWS_LIST_TYPE_RECIPIENT_ACTIVITY__VALUE,
  OPT_WORKFLOWS_LIST_TYPE_SUBSCRIPTION_DATE__VALUE,
  OPT_WORKFLOWS_LIST_TYPE_THANKS_FOR_JOIN__VALUE,
  OPT_WORKFLOWS_LIST_TYPE_UNSUBSCRIPTIONCAMPAIGN__VALUE,
  OPT_WORKFLOWS_LIST_TYPE_WELCOME_SERIES__VALUE,
  WORKFLOW_FIELD_TYPE_DATETIME,
  //
  WORKFLOW_FIELD_TYPE_DD_MM,
  WORKFLOW_FIELD_TYPE_DD_MM_YYYY,
  //
  WORKFLOW_FIELD_TYPE_INTEGER,
  WORKFLOW_FIELD_TYPE_MMDD,
  WORKFLOW_FIELD_TYPE_MM_DD,
  WORKFLOW_FIELD_TYPE_MM_DD_YYYY,
  WORKFLOW_FIELD_TYPE_TEXT,
  WORKFLOW_FIELD_TYPE_YYYYMMDD,
  WORKFLOW_FIELD_TYPE_YYYY_MM_DD,
  WORKFLOW_START_TYPE_ACTIVITY,
  WORKFLOW_START_TYPE_EVENT,
  WORKFLOW_START_TYPE_GROUP,
  WORKFLOW_START_TYPE_SUBSCRIBER_FIELD,
  WORKFLOW_START_TYPE_SUBSCRIPTION_DATE
} from 'Constants'

import { trustedEmailSenderState } from 'Hooks/useTrustedEmailSender/state'
import { trustedSmsSenderState } from 'Hooks/useTrustedSmsSender'
import { validateStep2 } from 'Pages/Workflow/validation/validation'
import { atom, selector, selectorFamily } from 'recoil'

import { WORKFLOW_START_TYPE_FILTERS } from 'Constants/index'
import {
  activiyTypeExistingFilterState,
  fieldTypeExistingFilterState,
  step2State
} from './step2'
import { step3State } from './step3'
import { step4State } from './step4'

export const WORKFLOWS_START_TYPE = {
  [OPT_WORKFLOWS_LIST_TYPE_EVENT__VALUE]: WORKFLOW_START_TYPE_EVENT,
  [OPT_WORKFLOWS_LIST_TYPE_SUBSCRIPTION_DATE__VALUE]:
    WORKFLOW_START_TYPE_SUBSCRIPTION_DATE,
  [OPT_WORKFLOWS_LIST_TYPE_FIELD_CONDITION__VALUE]:
    WORKFLOW_START_TYPE_SUBSCRIBER_FIELD,
  [OPT_WORKFLOWS_LIST_TYPE_GROUP_CONDITION__VALUE]: WORKFLOW_START_TYPE_GROUP,
  [OPT_WORKFLOWS_LIST_TYPE_RECIPIENT_ACTIVITY__VALUE]:
    WORKFLOW_START_TYPE_ACTIVITY,
  [OPT_WORKFLOWS_LIST_TYPE_THANKS_FOR_JOIN__VALUE]:
    WORKFLOW_START_TYPE_SUBSCRIPTION_DATE,
  [OPT_WORKFLOWS_LIST_TYPE_ONBOARDING__VALUE]:
    WORKFLOW_START_TYPE_SUBSCRIPTION_DATE,
  [OPT_WORKFLOWS_LIST_TYPE_BIRTHDAY__VALUE]: WORKFLOW_START_TYPE_EVENT,
  [OPT_WORKFLOWS_LIST_TYPE_EVENT_REMINDERS__VALUE]: WORKFLOW_START_TYPE_EVENT,
  [OPT_WORKFLOWS_LIST_TYPE_ABANDONED_CART__VALUE]: WORKFLOW_START_TYPE_EVENT,
  [OPT_WORKFLOWS_LIST_TYPE_WELCOME_SERIES__VALUE]:
    WORKFLOW_START_TYPE_SUBSCRIPTION_DATE,
  [OPT_WORKFLOWS_LIST_TYPE_UNSUBSCRIPTIONCAMPAIGN__VALUE]:
    WORKFLOW_START_TYPE_FILTERS
}

export const WORKFLOWS_PRECONFIGURED = [
  OPT_WORKFLOWS_LIST_TYPE_THANKS_FOR_JOIN__VALUE,
  OPT_WORKFLOWS_LIST_TYPE_ONBOARDING__VALUE,
  OPT_WORKFLOWS_LIST_TYPE_BIRTHDAY__VALUE,
  OPT_WORKFLOWS_LIST_TYPE_EVENT_REMINDERS__VALUE,
  OPT_WORKFLOWS_LIST_TYPE_ABANDONED_CART__VALUE,
  OPT_WORKFLOWS_LIST_TYPE_WELCOME_SERIES__VALUE,
  OPT_WORKFLOWS_LIST_TYPE_UNSUBSCRIPTIONCAMPAIGN__VALUE
]

/**
 * [{"Id":1,"Name":"iniziaCon"},
 * {"Id":2,"Name":"finisceCon"},
 * {"Id":3,"Name":"contiene"},
 * {"Id":4,"Name":"nonIniziaCon"},
 * {"Id":5,"Name":"nonFinisceCon"},
 * {"Id":6,"Name":"nonContiene"},
 * {"Id":7,"Name":"ugualeA"},
 * {"Id":8,"Name":"maggioreDi"},
 * {"Id":9,"Name":"maggioreUgualeA"},
 * {"Id":10,"Name":"minoreDi"},
 * {"Id":11,"Name":"minoreUgualeA"},
 * {"Id":12,"Name":"diversoDa"},
 * {"Id":18,"Name":"piuXGiorniUgualeAOggi"},
 * {"Id":19,"Name":"menoXGiorniUgualeAOggi"},
 * {"Id":20,"Name":"ugualeAOggi"},
 * {"Id":21,"Name":"piuXGiorniMinoreDiOggi"},
 * {"Id":22,"Name":"piuXGiorniMaggioreDiOggi"},
 * {"Id":23,"Name":"ugualeAl"},
 * {"Id":24,"Name":"primaDel"},
 * {"Id":25,"Name":"dopoIl"},
 * {"Id":26,"Name":"menoXGiorniMinoreDiOggi"},
 * {"Id":27,"Name":"menoXGiorniMaggioreDiOggi"},
 * {"Id":28,"Name":"NeNulloNeVuoto"},
 * {"Id":29,"Name":"NulloVuoto"},
 * {"Id":30,"Name":"plusXHoursEqualsToNow"}]
 *
 */

export const eventFieldTypes = [
  {
    value: WORKFLOW_FIELD_TYPE_DD_MM_YYYY,
    label: 'Load.MailupCommon.Date(dd/MM/yyyy)'
  },
  { value: WORKFLOW_FIELD_TYPE_DD_MM, label: 'Load.MailupCommon.Date(dd/MM)' },
  {
    value: WORKFLOW_FIELD_TYPE_MM_DD_YYYY,
    label: 'Load.MailupCommon.Date(MM/dd/yyyy)'
  },
  { value: WORKFLOW_FIELD_TYPE_MM_DD, label: 'Load.MailupCommon.Date(MM/dd)' },
  {
    value: WORKFLOW_FIELD_TYPE_YYYYMMDD,
    label: 'Load.MailupCommon.Date(yyyyMMdd)'
  },
  { value: WORKFLOW_FIELD_TYPE_MMDD, label: 'Load.MailupCommon.Date(MMdd)' },
  {
    value: WORKFLOW_FIELD_TYPE_YYYY_MM_DD,
    label: 'Load.MailupCommon.Date(yyyy-MM-dd)'
  },
  {
    value: WORKFLOW_FIELD_TYPE_DATETIME,
    label: 'Load.MailupCommon.Date(YYYY-MM-DDThh:mm:ssTZD)'
  }
]

export const eventFieldTypesBirthday = [
  { value: WORKFLOW_FIELD_TYPE_DD_MM, label: 'Load.MailupCommon.Date(dd/MM)' },
  { value: WORKFLOW_FIELD_TYPE_MM_DD, label: 'Load.MailupCommon.Date(MM/dd)' },
  { value: WORKFLOW_FIELD_TYPE_MMDD, label: 'Load.MailupCommon.Date(MMdd)' }
]

export const allFieldTypes = [
  { value: WORKFLOW_FIELD_TYPE_INTEGER, label: 'Load.MailupCommon.Integer' },
  { value: WORKFLOW_FIELD_TYPE_TEXT, label: 'Load.MailupCommon.Character' },
  ...eventFieldTypes
]

export const defaultWorkflow = {
  Action: false,
  ActivityType: 0,
  ActivityValue: 0,
  ActivityValueType: 0,
  ClickedLink: '',
  FieldType: 0,
  FieldValue: '',
  IdFieldFilter: 0,
  IdMessage: 0,
  IdFilter: 0,
  IdsFilter: [],
  RecipientLimit: 0,
  LastSendingPeriod: undefined,
  IdField: 0,
  IdGroup: 0,
  FrequencySafeGuard: 0,
  EndEmailStatus: undefined
}

export const emptyWorkflow = {
  Id: undefined,
  IdAggregateReport: undefined,
  Enabled: false,
  Draft: true,
  Type: undefined,
  StartType: undefined,
  Name: '',
  Notes: '',
  FromName: '',
  FromEmail: '',
  ReplyTo: '',
  FromSms: '',
  Tags: [],
  WizardStep: 1,
  MessageType: '',
  ...defaultWorkflow,
  EndFromGroup: -1,
  EndToGroup: 0,
  StartHour: null,
  StartDate: null,
  EndDate: null,
  NotInWeekends: false,
  BlackoutStartHour: null,
  BlackoutEndHour: null,
  Step: [],
  FrequencyBlackoutDate: [],
  FrequencySafeGuard: 0,
  Group: [],
  Filter: [],
  FiltersRule: 'AND',
  TimeZoneCode: undefined
}

//
const workflowDetailsState = atom({
  key: 'workflowDetailsState',
  default: {
    ...emptyWorkflow
  }
})

export const workflowDetails = selector({
  key: 'workflowDetails',
  get: ({ get }) => {
    return get(workflowDetailsState)
  },
  set: ({ set, get }, newValue) => {
    const wf = get(workflowDetailsState)
    const newWf = {
      ...wf,
      ...newValue
    }

    set(workflowDetailsState, newWf)
    set(step2State, {
      //  left
      Name: newWf.Name,
      Notes: newWf.Notes,
      FromName: newWf.FromName,
      FromEmail: newWf.FromEmail,
      ReplyTo: newWf.ReplyTo,
      FromSms: newWf.FromSms,
      Tags: newWf.Tags,

      //  right
      Action: newWf.Action,
      ActivityType: newWf.ActivityType,
      ActivityValue: newWf.ActivityValue,
      ActivityValueType: newWf.ActivityValueType,
      IdFilter: newWf.IdFilter,
      IdsFilter: newWf.IdsFilter,
      RecipientLimit: newWf.RecipientLimit,
      LastSendingPeriod: newWf.LastSendingPeriod,
      EndEmailStatus: newWf.EndEmailStatus,
      ClickedLink: newWf.ClickedLink,
      IdMessage: newWf.IdMessage,
      IdGroup: newWf.IdGroup,
      IdField: newWf.IdField,
      FieldType: newWf.FieldType,
      FieldValue: newWf.FieldValue,
      IdFieldFilter: newWf.IdFieldFilter
    })

    set(step3State, {
      Step: newWf.Step,
      EndFromGroup: newWf.EndFromGroup,
      EndToGroup: newWf.EndToGroup
    })

    set(step4State, {
      Group: newWf.Group,
      Filter: newWf.Filter,
      FiltersRule: newWf.FiltersRule,
      StartHour: newWf.StartHour,
      BlackoutStartHour: newWf.BlackoutStartHour,
      BlackoutEndHour: newWf.BlackoutEndHour,
      TimeZoneCode: newWf.TimeZoneCode,
      StartDate: newWf.StartDate,
      EndDate: newWf.EndDate,
      FrequencyBlackoutDate: newWf.FrequencyBlackoutDate,
      NotInWeekends: newWf.NotInWeekends,
      FrequencySafeGuard: newWf.FrequencySafeGuard
    })

    set(
      fieldTypeExistingFilterState,
      newWf.IdFilter > 0 ? 'use-existing' : 'use-custom'
    )

    set(
      activiyTypeExistingFilterState,
      newWf.IdFilter > 0 ? 'use-existing' : 'use-custom'
    )
  }
})

export const workflowCommonDataState = atom({
  key: 'workflowCommonDataState',
  default: {
    tags: [],
    // dynamicFields: [],
    profileFilters: [],
    profileFiltersCategories: [],
    activityFilters: [],
    activityFiltersCategories: [],

    startingFilters: [],
    startingFiltersCategories: [],

    groups: [],
    filters: [],
    emailMessages: [],
    emailMessageLinks: [],
    allowedProtocols: [],
    smsMessages: [],
    workflowEmails: {}, //  Id:Subject in step3
    workflowSms: {}, //  Id:Subject in step3,
    conditionsDescription: {
      StartCondition: undefined,
      EndCondition: undefined,
      WaitStep: []
    }
  }
})

export const workflowIsPreconfiguredState = selector({
  key: 'workflowIsPreconfiguredState',
  get: ({ get }) => {
    const { Type } = get(workflowDetails)
    return WORKFLOWS_PRECONFIGURED.includes(Type)
  }
})

export const workflowValidStep2State = selector({
  key: 'workflowValidStep2State',
  get: ({ get }) => {
    const step2 = get(step2State)
    const step3 = get(step3State)

    const { StartType } = get(workflowDetailsState)
    const { variant } = get(trustedEmailSenderState('workflowEdit'))
    const { variant: smsVariant } = get(
      trustedSmsSenderState('workflowEditSmsSender')
    )
    const fieldTypeExistingFilter = get(fieldTypeExistingFilterState)
    const activityTypeExistingFilter = get(activiyTypeExistingFilterState)

    return validateStep2(
      step2,
      StartType,
      variant,
      step3.Step.filter((e) => e.MessageType === 1).length > 0
        ? smsVariant
        : '',
      fieldTypeExistingFilter,
      activityTypeExistingFilter
    )
  }
})

export const workflowEmailMessageSubjectSelector = selectorFamily({
  key: 'workflowEmailMessageSubjectSelector',
  get:
    (idMessage) =>
    ({ get }) => {
      const { workflowEmails } = get(workflowCommonDataState)

      return workflowEmails[idMessage]
    }
})

export const workflowSmsMessageSubjectSelector = selectorFamily({
  key: 'workflowEmailMessageSubjectSelector',
  get:
    (idMessage) =>
    ({ get }) => {
      const { workflowSms } = get(workflowCommonDataState)

      return workflowSms[idMessage]
    }
})

export const workflowWaitSelector = selectorFamily({
  key: 'workflowEmailMessageSubjectSelector',
  get:
    (draggableId) =>
    ({ get }) => {
      const { Step } = get(step3State)

      const { mode } = Step.reduce(
        (acc, item) => {
          if (item.id === draggableId) {
            return {
              ...acc,
              found: true
            }
          }
          if (!acc.found && item.IdMessage > -1) {
            return {
              ...acc,
              mode:
                item.MessageType === WORKFLOW_MESSAGE_TYPE_EMAIL
                  ? 'email'
                  : item.MessageType === WORKFLOW_MESSAGE_TYPE_SMS
                    ? 'sms'
                    : ''
            }
          }
          return acc
        },
        { mode: 'email', found: false }
      )

      const item = Step.find(({ id }) => id === draggableId)

      return {
        ...item,
        mode
      }
    }
})

export const segmentationCriteriaState = atom({
  key: 'workflowSegmentationCriteriaState',
  default: {
    loading: false,
    loaded: false,
    error: false,
    severity: 'danger',
    groups: [],
    filters: [],
    includeGroups: [],
    excludeGroups: [],
    selectedFilters: []
  }
})

export const disableSendSameHour = selector({
  key: 'workflowSendSameHourSelector',
  get: ({ get }) => {
    const { StartType } = get(workflowDetails)
    const { Step } = get(step3State)
    const { FieldType, ActivityValue } = get(step2State)
    let waitTypeHour = false
    Step.forEach((e) => {
      if (e.ValueType === 1) {
        waitTypeHour = true
      }
    })

    return (
      StartType === WORKFLOW_START_TYPE_GROUP ||
      (StartType === WORKFLOW_START_TYPE_EVENT &&
        FieldType === WORKFLOW_FIELD_TYPE_DATETIME) ||
      (StartType === WORKFLOW_START_TYPE_SUBSCRIBER_FIELD &&
        (FieldType === WORKFLOW_FIELD_TYPE_INTEGER ||
          FieldType === WORKFLOW_FIELD_TYPE_TEXT ||
          FieldType === WORKFLOW_FIELD_TYPE_DATETIME)) ||
      (StartType === WORKFLOW_START_TYPE_SUBSCRIPTION_DATE &&
        ActivityValue === 0) ||
      (StartType === WORKFLOW_START_TYPE_ACTIVITY && ActivityValue === 0) ||
      waitTypeHour
    )
  }
})

export const step4ValidData = atom({
  key: 'workflowStep4ValidData',
  default: {
    validBlackoutHours: true,
    validSendingHour: true
  }
})

export const workflowValidStep4State = selector({
  key: 'workflowValidStep4',
  get: ({ get }) => {
    const { validBlackoutHours, validSendingHour } = get(step4ValidData)
    const { BlackoutStartHour, BlackoutEndHour } = get(step4State)

    const differentBlackoutHours =
      (BlackoutStartHour === null && BlackoutEndHour === null) ||
      BlackoutStartHour !== BlackoutEndHour

    return validBlackoutHours && validSendingHour && differentBlackoutHours
  }
})

export const step2DirtyState = selector({
  key: 'workflowStep2DirtyState',
  get: ({ get }) => {
    const {
      Name,
      Notes,
      FromName,
      FromEmail,
      ReplyTo,
      FromSms,
      Tags,

      Action,
      ActivityType,
      ActivityValue,
      ActivityValueType,
      IdFilter,
      IdsFilter,
      RecipientLimit,
      LastSendingPeriod,
      EndEmailStatus,
      ClickedLink,
      IdMessage,
      IdGroup,
      IdField,
      FieldType,
      FieldValue,
      IdFieldFilter
    } = get(workflowDetails)

    const wf = {
      Name,
      Notes,
      FromName,
      FromEmail,
      ReplyTo,
      FromSms,
      Tags,

      Action,
      ActivityType,
      ActivityValue,
      ActivityValueType,
      IdFilter,
      IdsFilter,
      RecipientLimit,
      LastSendingPeriod,
      EndEmailStatus,
      ClickedLink,
      IdMessage,
      IdGroup,
      IdField,
      FieldType,
      FieldValue,
      IdFieldFilter
    }

    const step2Data = get(step2State)

    //  console.log(JSON.stringify(wf))
    //  console.log(JSON.stringify(step2Data))

    return JSON.stringify(wf) !== JSON.stringify(step2Data)
  }
})

const wfStepFilter = ({
  Id,
  IdMessage,
  WaitType,
  Value,
  ValueType,
  MessageType
}) => ({ Id, IdMessage, WaitType, Value, ValueType, MessageType })

export const step3DirtyState = selector({
  key: 'workflowStep3DirtyState',
  get: ({ get }) => {
    const { Step: aStep, EndFromGroup, EndToGroup } = get(workflowDetails)

    const { Step: bStep, ...step3Data } = get(step3State)

    const objA = {
      Step: aStep.map(wfStepFilter),
      EndFromGroup,
      EndToGroup
    }

    const objB = {
      Step: bStep.map(wfStepFilter),
      ...step3Data
    }

    //  console.log('*****')
    //  console.log(JSON.stringify(objA))
    //  console.log(JSON.stringify(objB))

    return JSON.stringify(objA) !== JSON.stringify(objB)
  }
})

export const step4DirtyState = selector({
  key: 'workflowStep4DirtyState',
  get: ({ get }) => {
    const {
      Group,
      Filter,
      FiltersRule,
      StartHour,
      BlackoutStartHour,
      BlackoutEndHour,
      TimeZoneCode,
      StartDate,
      EndDate,
      FrequencyBlackoutDate,
      NotInWeekends,
      FrequencySafeGuard
    } = get(workflowDetails)

    const wf = {
      Group,
      Filter,
      FiltersRule,
      StartHour,
      BlackoutStartHour,
      BlackoutEndHour,
      TimeZoneCode,
      StartDate,
      EndDate,
      FrequencyBlackoutDate,
      NotInWeekends,
      FrequencySafeGuard
    }

    const step4Data = get(step4State)

    //  console.log(JSON.stringify(wf))
    //  console.log(JSON.stringify(step4Data))

    return JSON.stringify(wf) !== JSON.stringify(step4Data)
  }
})
